<div style="display:flex">
  <div class="float-left">
    <span class="input-name pe-1" [class.disabled]="disabled">{{name}}</span>
  </div>
  <div class="float-left switchBox">
    <label class="switch">
      <input type="checkbox" [(ngModel)]="value" [disabled]="!!disabled" (change)="onSaveModel()">
      <span class="slider round test"></span>
    </label>
  </div>
</div>
